// Importing styles
import '../css/composer.scss';
import { initVideoPlugin } from './plugins/videobox/init_videobox.js';
import {initScrollButton} from "./plugins/scrollbutton/init_scrollbutton.js";
import {initProgressPlugin} from "./plugins/progress/init_progress.js";
import {initFxScroll} from "./fx/init_fx_scroll.js";
import {initFxTxt} from "./fx/init_fx_text.js";
import {initFxPreviewListener} from "./fx/init_fx_preview.js";
import {initComparisonPlugin} from "./plugins/image_comparison/init_comparison.js";
import {initNumberCounterPlugin} from "./plugins/number_counter/init_number_counter.js";
import {initRevealPlugin} from "./plugins/reveal_wrapper/init_reveal_animation.js";
import {initScrollyPlugin} from "./plugins/scrolly_telling/init_scrollytelling.js";
import {initTabsPlugin} from "./plugins/tabs/init_tabs.js";
import {initManifestoPlugin} from "./plugins/manifesto/init_manifesto.js";
import {initMagneticCardPlugin} from "./plugins/magnetic_card/init_magnetic_card.js";
import {initMosaicWrapper} from "./plugins/mosaic_wrapper/init_mosaic_wrapper.js";
import {initScenicPan} from "./plugins/scenic_pan/init_scenic_pan.js";
import {initStackWrapper} from "./plugins/stack_wrapper/init_stack_wrapper.js";
import {initCinematicParallax} from "./plugins/cinematic_parallax/init_cinematic.js";
import {initFittyText} from "./plugins/fitty_wrapper/init_fitty.js";
import {initHotspots} from "./plugins/hotspots/init_hotspots.js";
import {initAllInfographics} from "./plugins/infographic/init_infographic.js";
import {initTimelinePlugin} from "./plugins/simple_timeline/init_timeline.js";
import {initAnimatedLogos} from "./plugins/project_specific/animated_logo/init_animated_logos.js";


// Initializing all plugins logics
function initializeAllPlugins() {
    initFxScroll();
    initVideoPlugin();
    initScrollButton();
    initProgressPlugin();
    initFxPreviewListener();
    initComparisonPlugin();
    initNumberCounterPlugin();
    initRevealPlugin();
    initScrollyPlugin();
    initTabsPlugin();
    initManifestoPlugin();
    initMagneticCardPlugin();
    initMosaicWrapper();
    initScenicPan();
    initStackWrapper();
    initCinematicParallax();
    initFittyText();
    initFxTxt();
    initHotspots();
    initAllInfographics();
    initTimelinePlugin();
    initAnimatedLogos();
}

document.addEventListener('DOMContentLoaded', initializeAllPlugins);
